import mwcMarketsCore from 'mwc-markets-core';
import Component from './src/autocomplete.vue';

const { createCustomElement } = mwcMarketsCore;

export default createCustomElement(Component);
